import ApiCall from "./ApiCalls";

const autocomplete = (options, value) => {
  let path = options.url;

  let parameter = "";
  parameter += getValue("term", value);
  parameter += getValue("record", options.resultCount);
  parameter += getValue("cityId", options.cityId);
  parameter += getValue("sourceId", options.source);
  let url = createUrl(parameter, path);
  return url;
};

const carAutocomplete = (options, value) => {
  let path = options.url;

  let parameter = "";
  parameter += getValue("value", value);
  parameter += getValue("size", options.resultCount);
  parameter += getValue("sourceId", options.source);
  parameter += getValue("source", options.sourceIndex);
  parameter += getValue("showFeaturedCar", options.showFeaturedCar);
  let url = createUrl(parameter, path);
  return url;
};

const createUrl = (parameter, path) => {
  if (parameter) {
    parameter = parameter.slice(0, -1);
    path += "?" + parameter;
  }

  return ApiCall.fetchApi({
    url: path,
    requestInit: {
      headers: { Accept: "application/json" },
    },
  });
};

const getValue = (key, value) => {
  if (value) {
    return key + "=" + value + "&";
  }

  return "";
};

export { autocomplete, carAutocomplete };
